import { trigger, state, animate, transition, style } from '@angular/animations';

export const routerAnimation =
    trigger('routerAnimation', [
        transition('* => *', [

            // styles at start of transition
            style({ transform: 'translateY(20px)', opacity: 0 }),

            // animation and styles at end of transition
            animate('.4s', style({ transform: 'translateY(0)', opacity: 1 }))
        ]),
        // transition('* => void', [

        //     // styles at start of transition
        //     style({ opacity: 0 }),

        //     // animation and styles at end of transition
        //     animate('1s', style({ opacity: 1 }))
        // ])
    ]);


// WEBPACK FOOTER //
// /mnt/disk/stratbox.dev/src/app/animations/router.animation.ts